import styled from 'styled-components';

export const SlotContainer = styled.div`
  display: flex;
  flex-direction: row;
`

export const CardMessage = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.white};
  border-radius: 6px;
  box-shadow: 0 7px 15px 0 rgba(0, 0, 0, 0.04);
  flex-direction: row;
  padding: 12px 15px;
  margin-bottom: 15px;
`

export const CardMsgFlex = styled(CardMessage)`
  flex: 1;
`

export const Chips = styled.div`
  display: flex;
  height: 25px;
  padding: 4px 8px;
  margin: 4px;
  background-color: ${({ theme }) => theme.mocaGreen};
  border-radius: 6px;
  align-content: center;
  align-items: center;
`

export const ItemRoundedGreen = styled.div`
  display: flex;
  flex-direction: column;
  width: 15px;
  height: 15px;
  border-radius: 15px;
  position: absolute;
  top: 3px;
  background-color: ${({ theme }) => theme.mocaGreen};
`

export const LineTop = styled.div`
  display: flex;
  flex-direction: column;
  height: 12px;
  width: 2px;
  background-color: ${({ first, theme }) => first ? theme.mocaGreen : 'transparent'};
`

export const LineBot = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 2px;
  background-color: ${({ last, theme }) => last ? theme.mocaGreen : 'transparent'};
`

export const LeftSlot = styled.div`
  position: relative;
  display: flex;
  width: 30px;
  align-items: center;
  flex-direction: column;
`

export const RightSlot = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-top: 3px;
`

export const DateSlot = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
`

export const CardTitleSlot = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 12px;
  flex: 1;
`

export const CardContentSlot = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  align-items: flex-start;
  flex-direction: row;
  margin-top: ${({ mt }) => mt || '10px'};
`

export const RowSlot = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-start;
  flex-direction: row;
`
